import { DotList } from '@motorway/mw-highway-code';

import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';
import { autoShorthand, formatText, formatTransmission } from 'Utilities/formatters';

interface VehicleSummaryItemProps {
	id: string;
	item?: string | number;
}

export const VehicleSummaryItem: React.FC<VehicleSummaryItemProps> = ({ id, item }) => {
	if (!item) {
		return null;
	}
	return <li data-testid={id}>{item}</li>;
};

interface VehicleSummaryProps {
	fuel: VehicleData['mainInfo']['fuel'];
	mileage: number;
	transmission: VehicleData['mainInfo']['transmission'];
	year: number;
}

export const VehicleSummary: React.FC<VehicleSummaryProps> = ({ fuel, mileage, transmission, year }) => {
	return (
		<section>
			<DotList>
				<VehicleSummaryItem id="year" item={year} />
				<VehicleSummaryItem id="mileage" item={`${formatText(mileage)} miles`} />
				<VehicleSummaryItem id="fuel" item={fuel} />
				<VehicleSummaryItem id="transmission" item={autoShorthand(formatTransmission(transmission))} />
			</DotList>
		</section>
	);
};
